module.exports = __webpack_public_path__ + "img/arrowLeft.80ca8231.svg";